import { render, staticRenderFns } from "./KnowledgeView.vue?vue&type=template&id=3b6ea3fa&"
import script from "./KnowledgeView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports